import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Card,
  CardContent,
  Typography,
  Divider,
  TableSortLabel,
  TextField,
  useTheme,
  MenuItem,
  Grid,
  Button,
} from "@mui/material";
import Icons from "../../Utils/Icons";
import { GET } from "../Generic/CrudRequest";
import useExcelExport from "../../Utils/useExcelExport";
import { SaveAlt } from "@mui/icons-material";
import { searchPermissions } from "../Users/PermissionsUser/PermissionsActions";

const columns = [
  { id: "idContacto", label: "ID Contacto", minWidth: "100px" },
  { id: "nombre", label: "Nombre", minWidth: "150px" },
  { id: "correo", label: "Correo Electrónico", minWidth: "200px" },
];

export default function Contact({ config }) {
  const { t } = useTranslation();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [orderBy, setOrderBy] = useState("");
  const [order, setOrder] = useState("asc");
  const [column, setColumn] = React.useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [estatus, setEstatus] = React.useState(true);
  const theme = useTheme();
  const exportToExcel = useExcelExport();
  const [register, setRegister] = useState(false);
  const [edit, setEdit] = useState(false);

  // Configurar columnas con traducciones
  const translatedColumns = [
    { id: "idContacto", label: t("contacts.idContact"), minWidth: "100px" },
    { id: "nombre", label: t("contacts.name"), minWidth: "150px" },
    { id: "correo", label: t("contacts.email"), minWidth: "200px" },
  ];

  useEffect(() => {
    fetchContacts();
  }, [page, rowsPerPage, column, order]);

  const fetchContacts = async () => {
    const dataContacts = await GET(`${config.url}/api/Contact/paginado`, {
      start: page * rowsPerPage,
      length: rowsPerPage,
      nombre: searchText,
      column: column,
      dir: order,
      status: estatus
    });

    setRows(dataContacts.resultado);
    setTotalRecords(dataContacts.totalRegistros);

    const permissionsArray = JSON.parse(localStorage.getItem("permissions"));
    
    const permissionRegister = searchPermissions(
      "Contactos",
      "Registrar",
      permissionsArray
    );

    const permissionEdit = searchPermissions(
      "Contactos",
      "Editar",
      permissionsArray
    );

    setRegister(permissionRegister);
    setEdit(permissionEdit);
  };
  const handleSearch = () => {
    fetchContacts();
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleClear = () => {
    setSearchText("");
    setEstatus(true);
  };
  const handleRequestSort = (property, columnNumber) => {
    const isAsc = orderBy === property && order === "asc";

    setColumn(columnNumber);
    setOrderBy(property);
    setOrder(isAsc ? "desc" : "asc");
  };
  const handleChangeEstatus = (event) => {
    setEstatus(event.target.value);
  };

  const handleExport = () => {
    exportToExcel(rows, translatedColumns, t("contacts.excelTitle"));
  };
  return (
    <Card
      variant="outlined"
      sx={{
        overflow: "hidden",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
        border: "1px solid rgba(0, 0, 0, 0.1)",
        borderRadius: 2,
      }}
    >
      <CardContent>
        <CardContent
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            justifyContent: "space-between",
            overflow: "hidden",
            maxWidth: "100%",
          }}
        >
          <Typography variant="h3" sx={{ fontWeight: "bold" }}>
            {t("contacts.title")}
          </Typography>
          {register && (
            <Icons
              iconName="Add"
              fontSize="large"
              to="/Contactos/Agregar"
              style={{
                marginLeft: "auto",
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.white.main,
              }}
              tooltip={t("buttons.add")}
            />
          )}

        </CardContent>
        <Divider sx={{ maxWidth: "calc(100% - 32px)", margin: "auto" }} />
        <CardContent
          sx={{
            maxWidth: "calc(100% - 32px)",
            margin: "auto",
            alignItems: "auto",
          }}
        >  <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <TextField
                label={t("contacts.name")}
                type="search"
                InputLabelProps={{
                  shrink: true,
                }}
                variant="standard"
                size="small"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                sx={{
                  width: 400,
                  maxWidth: "100%",
                  color: theme.palette.primary.main,
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                select
                label={t("contacts.status")}
                InputLabelProps={{
                  shrink: true,
                }}
                name="estatus"
                variant="standard"
                size="small"
                value={estatus}
                fullWidth
                onChange={handleChangeEstatus}
              >
                <MenuItem value={true}>{t("contacts.active")}</MenuItem>
                <MenuItem value={false}>{t("contacts.inactive")}</MenuItem>
              </TextField>
            </Grid>
            <Icons
              iconName="Search"
              fontSize="large"
              onClick={handleSearch}
              style={{ color: theme.palette.primary.main }}
              tooltip={t("buttons.search")}
            />
            <Icons
              iconName="Clear"
              fontSize="large"
              onClick={handleClear}
              style={{ color: theme.palette.primary.main }}
              tooltip={t("buttons.clear")}
            />
          </Grid>
        </CardContent>
        <Paper
                 sx={{
                   maxWidth: "calc(100% - 32px)",
                   margin: "auto",
                   overflow: "hidden",
                   boxShadow: "none",
                   border: "none",
                 }}
               >
        <TableContainer>
        <Button
          variant="contained"
          startIcon={<SaveAlt />}
          onClick={handleExport}
        >
          {t("buttons.exportExcel")}
        </Button>
          <Table stickyHeader aria-label="sticky table">
                       <TableHead>
                         <TableRow>
                           {translatedColumns.map((column) => (
                             <TableCell
                               key={column.id}
                               align="left"
                               style={{ minWidth: column.minWidth, fontWeight: "bold" }}
                             >
                               <TableSortLabel
                                 active={orderBy === column.id}
                                 direction={orderBy === column.id ? order : "asc"}
                                 onClick={() =>
                                   handleRequestSort(column.id, columns.indexOf(column))
                                 }
                               >
                                 {column.label}
                               </TableSortLabel>
                             </TableCell>
                           ))}
                           <TableCell />
                         </TableRow>
                       </TableHead>
                       <TableBody>
                         {rows.length === 0 && (
                           <TableRow>
                             <TableCell colSpan={translatedColumns.length + 1} align="center">
                               {t("contacts.noContactsAvailable")}
                             </TableCell>
                           </TableRow>
                         )}
                         {rows.map((row, index) => {
                           return (
                             <TableRow key={index}>
                               {translatedColumns.map((column) => (
                                 <TableCell key={column.id} align="left">
                                   {row[column.id] !== null && row[column.id] !== "" ? (
                                     row[column.id]
                                   ) : (
                                     <i>{t("contacts.notAvailable")}</i>
                                   )}
                                 </TableCell>
                               ))}
                               <TableCell align="right">
                                 {edit && (
                                   <Icons
                                     iconName="Edit"
                                     fontSize="medium"
                                     style={{
                                       backgroundColor: theme.palette.primary.main,
                                       color: "#fff",
                                     }}
                                     to={`/Contactos/Editar/${row.idContacto}`}
                                     tooltip={t("buttons.edit")}
                                   />
                                 )}
                               </TableCell>
                             </TableRow>
                           );
                         })}
                       </TableBody>
                     </Table>
                   </TableContainer>
                   <TablePagination
                     rowsPerPageOptions={[10, 25, 100, { value: -1, label: t("pagination.all") }]}
                     component="div"
                     count={totalRecords}
                     rowsPerPage={rowsPerPage}
                     page={page}
                     onPageChange={handleChangePage}
                     onRowsPerPageChange={handleChangeRowsPerPage}
                     labelRowsPerPage={t("pagination.labelRowsPerPage")}
                     labelDisplayedRows={({ from, to, count }) =>
                       t("pagination.displayedRows", { from, to, count })
                     }
                   />
                 </Paper>
               </CardContent>
             </Card>
           );
         }
         